import React from "react";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
// img
import h1 from "../../../assets/images/hgame.png";
import h2 from "../../../assets/images/hleaderboard.png";
import styles from "./HowToPlay.module.scss";

const HowToPlayPop = ({ playInst, setPlayInst }) => {
  const handlePlayInst = () => {
    setPlayInst(!playInst);
  };
  return (
    <>
      <Modal
        show={playInst}
        onHide={handlePlayInst}
        backdrop="true"
        centered
        className={`${styles.HowToPlayPop} bottomPop allow-scroll`}
        keyboard={false}
        scrollable="true"
      >
        <div className="modalWrpper">

          <Modal.Body>
            <Button
              onClick={handlePlayInst}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3 text-center">
              <h5
                className="m-0 text-white d-inline-block  pb-1 px-3"
                style={{ borderBottom: "1px solid #02ADEA" }}
              >
                How to play
              </h5>
            </div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="Game">
              <Nav
                variant="pills"
                className="justify-content-center inline-flex rounded-4 mx-auto p-1 PillsTab"
                style={{
                  background: "#13131b",
                  border: "1px solid #13131b",
                  maxWidth: "max-content",
                }}
              >
                <Nav.Item>
                  <Nav.Link
                    className="d-flex align-items-center justify-content-center p-1 fw-bold"
                    eventKey="Game"
                  >
                    Game
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="d-flex align-items-center justify-content-center p-1 fw-bold"
                    eventKey="Leaderboard"
                  >
                    Leaderboard
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content

                style={{ fontSize: 14, lineHeight: "20px" }}
              >
                <Tab.Pane eventKey="Game">
                  <div className="py-2">
                    <div >
                      <ul className="text-white mb-0" style={{ fontSize: 12 }}>
                        <li className="">Click “Start” to reveal four shiny blue squares.</li>
                        <li className="">Pick one square to uncover either a BTNC or a Bomb!</li>
                        <li className="">Find a BTNC? Awesome! You get to keep playing.</li>
                        <li className="">Hit a Bomb? Uh-oh! The round ends, but any BTNC <br /> you collected stays in your balance.</li>
                        <li className="">Open 5 or more lines, and you have a chance to win <br />USDT or MEME Coins!</li>
                        <li className="">Running low on ENERGY? No problem! You can buy <br />more using BTNC.</li>
                        <li className="">If your energy is below 9, it refills by 1, 2, or 3 <br />every 8 hours.</li>
                        <li className="">
                          All won cryptocurrency claims will be confirmed within 24 hours.
                        </li>
                        <li className="">
                          Crypto claims made on weekends will be confirmed by 3 PM GMT+4 on Monday.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="pb-2 text-center" style={{ marginBottom: 10 }}>
                    <img src={h1} alt="" className="img-fluid object-fit-contain" style={{ height: 280 }} />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="Leaderboard">
                  <div>
                    <ul className="text-white mb-0" style={{ fontSize: 12 }}>
                      <li className="">The scoring system is super easy.
                      </li>
                      <li className="">Move up to line X and earn X points! </li>
                      <li className="">for example, if you open two squares but hit a Bomb <br /> on the third, you’ll score 2 points.</li>
                      <li className="">  Check the leaderboard timer in the top- left corner of <br /> the section.</li>
                      <li className="">To receive a prize on the leaderboard, your account <br />must be linked to Bitanica.com.</li>
                      <li className="">You have 24 hours to link your account, otherwise,<br /> the prize will be last.</li>
                      <li className="">All prizes will be deposited every Monday by 3 PM <br /> GMT+4.</li>
                    </ul>
                  </div>
                  <div className="pb-2 text-center">
                    <img src={h2} alt="" className="img-fluid object-fit-contain" style={{ height: 280 }} />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Modal.Body>
        </div>
      </Modal >
    </>
  );
};

export default HowToPlayPop;
